export default "__VITE_PUBLIC_ASSET__27fe31cf__"